import {
  CollisionObjectProps,
  CollisionShape,
  CollisionType,
} from "./CollisionTypes";
import { getBooleanPropBuilder } from "../FeatureUtils";

export type PCOP = Partial<CollisionObjectProps>;

export const InteractionContextPresets: Record<
  string,
  PCOP | ((userData: Record<string, any>) => PCOP)
> = {
  Box: getBooleanPropBuilder<PCOP>("Box", {
    collisionShape: CollisionShape.Box,
    collisionType: CollisionType.Dynamic,
    parentToCollision: true,
  }),
  Ball: getBooleanPropBuilder<PCOP>("Ball", {
    collisionShape: CollisionShape.Sphere,
    collisionType: CollisionType.Dynamic,
    parentToCollision: true,
  }),
  Wall: getBooleanPropBuilder<PCOP>("Wall", {
    collisionShape: CollisionShape.Box,
    friction: 0,
  }),
  ComplexWall: getBooleanPropBuilder<PCOP>("ComplexWall", {
    collisionShape: CollisionShape.Trimesh,
    friction: 0,
  }),
  Structure: getBooleanPropBuilder<PCOP>("Structure", {
    collisionShape: CollisionShape.Trimesh,
  }),
  Platform: getBooleanPropBuilder<PCOP>("Platform", {
    collisionShape: CollisionShape.Trimesh,
    collisionType: CollisionType.KinematicPosition,
    collisionAttach: true,
    friction: 1,
    restitution: -4,
  }),
  RotatingPlatform: getBooleanPropBuilder<PCOP>("RotatingPlatform", {
    collisionShape: CollisionShape.Trimesh,
    collisionType: CollisionType.KinematicPosition,
    collisionMatchRotation: true,
    friction: 1,
    restitution: -4,
  }),
  Player: getBooleanPropBuilder<PCOP>("Player", {
    collisionShape: CollisionShape.Box,
    collisionType: CollisionType.Dynamic,
    isPlayer: true,
    restitution: 0.5,
    parentToCollision: true,
  }),
  Sticky: getBooleanPropBuilder<PCOP>("Sticky", {
    collisionShape: CollisionShape.Trimesh,
    collisionType: CollisionType.KinematicPosition,
    friction: 5,
  }),
  Mass: ({ Mass = 1 } = {}) => {
    const mass = parseFloat(`${Mass}`);

    return {
      mass: isNaN(mass) ? 1 : mass,
    };
  },
  Trigger: getBooleanPropBuilder<PCOP>("Trigger", {
    sensor: true,
  }),
  Speaker: {
    sensor: true,
  },
  SpeakerTrigger: {
    sensor: true,
  },
};
